import SliceZone from './SliceZone';
import { RichText } from 'prismic-reactjs';
import PrismicLink from '@components/PrismicLink';
import { useContext } from 'react';
import { LayoutContext } from '@context/LayoutContext';

const Top = () => {
  const { announcement } = useContext(LayoutContext);

  return (
    <>
      <div className="container">
        <div
          className="header-limited-width-container container-flex"
          data-testid="top-header"
        >
          {announcement?.link && (
            <PrismicLink link={announcement.link}>
              <div className="announcement">
                {announcement?.text ? (
                  <RichText render={announcement.text} />
                ) : null}
              </div>
            </PrismicLink>
          )}
          <div className="nav">
            <nav role="navigation">
              <ul>
                <SliceZone />
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <style jsx>{`
        .container {
          background-color: var(--clr-tertiary-2);
        }

        .container-flex {
          display: flex;
          justify-content: space-between;
          background-color: var(--clr-tertiary-2);
          align-items: center;
          padding-top: var(--space-1);
          padding-bottom: var(--space-1);
          color: var(--black);
        }

        .announcement {
          display: flex;
          cursor: pointer;
          align-items: center;
        }

        .announcement > :global(p) {
          margin-left: var(--space-1);
          color: var(--black);
        }

        .announcement > :global(span) {
          display: flex;
          justify-content: center;
        }

        .nav > nav > ul {
          display: flex;
        }

        ul > :global(li) {
          margin-left: var(--space-6);
        }

        .container :global(.label:hover),
        .container :global(a:hover) {
          text-decoration: underline;
        }

        .container :global(.dropdown-content a:hover) {
          color: inherit;
          text-decoration: inherit;
          transition: all 0.3s ease;
          background-color: var(--clr-primary-5);
        }

        @media (max-width: 800px) {
          .container {
            display: none;
          }

          .announcement > :global(p) {
            font-size: 12px;
          }
        }
      `}</style>
    </>
  );
};

export default Top;
